import { render, staticRenderFns } from "./salesGoods.vue?vue&type=template&id=635cf2d3&scoped=true"
import script from "./salesGoods.vue?vue&type=script&lang=js"
export * from "./salesGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cf2d3",
  null
  
)

export default component.exports